import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { getScientistById, getAgencyById } from '../services/dataService';
import { getScientistImage } from '../utils/imageUtils';

/**
 * Scientist Profile Page Component
 */
const ScientistDetails = () => {
  const { id } = useParams();
  const scientist = getScientistById(id);
  const agency = scientist ? getAgencyById(scientist.agencyId) : null;

  if (!scientist) {
    return (
      <div className="container" style={{ paddingTop: '50px', textAlign: 'center' }}>
        <h2>Scientist not found</h2>
        <Link to="/scientists" className="btn btn-primary" style={{ marginTop: '20px' }}>Back to Scientists</Link>
      </div>
    );
  }

  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <Link to="/scientists" className="btn btn-secondary" style={{ marginBottom: '20px' }}>
        ← Back to Scientists
      </Link>

      <div className="card" style={{ marginBottom: '30px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '300px 1fr', gap: '30px', marginBottom: '20px' }}>
          <img 
            src={getScientistImage(scientist.id, scientist.name)} 
            alt={scientist.name}
            style={{ 
              width: '100%', 
              height: '400px', 
              objectFit: 'cover', 
              borderRadius: '8px'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <div>
            <h1 style={{ fontSize: '36px', color: 'var(--highlight-color)', marginBottom: '20px' }}>
              {scientist.name}
            </h1>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
              <div>
                <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>Professional Information</h3>
                <p style={{ marginBottom: '10px' }}><strong>Field:</strong> {scientist.field}</p>
                <p style={{ marginBottom: '10px' }}><strong>Country:</strong> {scientist.country}</p>
                {agency && (
                  <p style={{ marginBottom: '10px' }}>
                    <strong>Agency:</strong> <Link to={`/agencies/${agency.id}`} style={{ color: 'var(--highlight-color)' }}>{agency.name}</Link>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>Biography</h3>
          <p style={{ color: 'var(--text-dark)', lineHeight: '1.8' }}>
            {scientist.biography}
          </p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>Notable Achievements</h3>
          <p style={{ color: 'var(--text-dark)', lineHeight: '1.8' }}>
            {scientist.achievements}
          </p>
        </div>

        {scientist.rocketsWorkedOn && scientist.rocketsWorkedOn.length > 0 && (
          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>Rockets Worked On</h3>
            <ul style={{ paddingLeft: '20px', color: 'var(--text-dark)' }}>
              {scientist.rocketsWorkedOn.map((rocket, index) => (
                <li key={index}>{rocket}</li>
              ))}
            </ul>
          </div>
        )}

        {scientist.satellitesWorkedOn && scientist.satellitesWorkedOn.length > 0 && (
          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>Satellites Worked On</h3>
            <ul style={{ paddingLeft: '20px', color: 'var(--text-dark)' }}>
              {scientist.satellitesWorkedOn.map((satellite, index) => (
                <li key={index}>{satellite}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScientistDetails;
